module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step2_Image22.fdbc1ce5.jpg";